<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "archive" });
export let css = "";
export let isScaling = true;
</script>

<svg
    xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 24 24'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <path
        d = 'M16 14L12.5 17.5L9 14M4.5 7.5V20.5H20.5V7.5L18.5 4.5H6.5L4.5 7.5Z'
        stroke-width = '1.2'
        vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }
    />
    <path
        d = 'M12.5 10.5V17'
        stroke-width = '1.2'
        vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }
    />
    <path
        d = 'M4.5 7.5H20.5'
        stroke-width = '1.2'
        vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }
    />
</svg>